import React from 'react';
import { AccordionBodyItemView } from 'component/Accordion';
import { ReactComponent as CheckBoxIcon } from 'assets/images/icons/check_box_24(1).svg';

export const ImprovisedView = (props) => {
  const { formData } = props;

  return (
    <AccordionBodyItemView
      accordionSubId="3.6"
      titleUA="Саморобні вибухові пристрої"
      titleEN="Improvised Explosive Device"
      children={
        formData.info.hazard_type.improvised_explosive_device && (
          <CheckBoxIcon />
        )
      }
    />
  );
};
